export enum PromoTypeEnum {
    NA = 0,
    FreeDelivery = 2,
    Referral = 3,
    Discount = 4,
    PercentageDiscount = 5,
    FixedAmountDiscount = 6,
    DeliveryFeeDiscount = 7,
    FreeItemPromo = 8,
    Cebuana24K = 9
}
